module.exports = __webpack_public_path__ + "media/images/flags/1x1/nam-4999c4eea80a2ca310d7a525a9a02fcf.svg";